<template>
  <div class="jojo_about">
     <div>
        <img src="../assets/icon_phone2.svg" />Please open this invite link with your mobile phone!
     </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
    }
  },
  mounted () {
  },
   components: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jojo_about {
  min-height:calc(~"100% - 202px");
  display: flex;
  justify-items: center;
  align-items: center;
  >div {
    position:relative;
    background: #282828;
    border-radius: 20px;
    margin:auto;
    padding:77px 57px 78px 134px;
    width: 220px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 26px;
    img {
      position:absolute;
      width:66px;
      height:104px;
      left:43px;
      top:50px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue